import CardHeader from "components/CardHeader";
import React from "react";
import {connect} from "react-redux";
import {RootState} from "store/store";
import {Card, CardBody} from "reactstrap";
import {CallsState} from "../../store/reducers/Calls";
import {Link} from "react-router-dom";
import Date from "../../components/Date";
import {PersonsState} from "../../store/reducers/Persons";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

interface Props {
    callState: CallsState;
    persons: PersonsState;
}

interface OwnProps { limit?: number; }

const RecentCallsCard: React.FC<Props & OwnProps> = ({limit = 20, persons, callState}) => {
    const {t} = useOfficeTranslation();

    const statusMap: { [index: string]: JSX.Element } = {
        "ANSWERED": <i className="fa fa-check" title={t("dashboard.recentCallsCard.answered")}/>,
        "ENQUEUED": <i className="fa fa-hourglass" title={t("dashboard.recentCallsCard.enqueued")}/>,
        "BLOCKED": <i className="fa fa-ban" title={t("dashboard.recentCallsCard.blocked")}/>,
        "REJECTED-OOO": <i className="fa fa-clock" title={t("dashboard.recentCallsCard.outOfOffice")}/>,
        "LEFT": <i className="fa fa-arrow-circle-right" title={t("dashboard.recentCallsCard.leftQueue")}/>,
    }

    return (
        <Card className="h-100 mb-0 dashboard-widget-card">
            <CardBody>
                <CardHeader title={t("dashboard.recentCallsCard.recentCalls")} icon="mdi-phone-outline" count={callState.getCalls().length} />
                {callState.getCalls().length === 0 ?
                    <p className="text-muted mt-3 mb-0">{t("dashboard.recentCallsCard.noCallsFound")}</p>
                    :
                    <div className="dashboard-widget-scroll">
                        {callState.getCalls()
                            .sort((a, b) => (a.date < b.date) ? 1 : (a.date > b.date) ? -1 : 0)
                            .slice(0, limit)
                            .map(call => {
                                let person = persons.getPersonById(call.person)
                                if (person === null) {
                                    person = persons.getPersonByPhone(call.from)
                                }

                                return <div key={call.id} className="d-flex justify-content-between align-items-center gap-3 border-bottom py-3">
                                    <div className="min-w-0">
                                        <strong className="text-truncate d-block">{person === null ? call.from : <Link
                                            to={`/persons/${person.id}`}>{person.name} ({call.from})</Link>}</strong>
                                        <small className="text-muted"><Date date={call.GetDate()}/></small>
                                    </div>
                                    <span title={call.status} className="badge bg-primary bg-soft text-primary flex-shrink-0">
                                        {statusMap[call.status]}
                                    </span>
                                </div>;
                            })}
                    </div>
                }
            </CardBody>
        </Card>
    );
}

const mapStateToProps = (state: RootState) => {
    return {
        persons: state.Persons,
        callState: state.Calls,
    };
};

export default connect(mapStateToProps)(RecentCallsCard);
